<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>分账单</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="应用名称">
          <el-input v-model="formSearch.applyname" placeholder="商户名称"></el-input>
        </el-form-item>
        <el-form-item label="查询周期">
          <el-date-picker
            v-model="billmonth"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="formSearch.payment" clearable placeholder="请选择">
            <el-option label="微信" value="wx"></el-option>
            <el-option label="支付宝" value="zfb"></el-option>
            <el-option label="腾讯微信" value="twx"></el-option>
            <el-option label="Alipay支付宝" value="dyzfb"></el-option>
            <el-option label="微信 支付" value="ybwx"></el-option>
            <el-option label="支付宝 支付" value="ybzfb"></el-option>
            <el-option label="小程序" value="wechat"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formSearch.billstate" clearable placeholder="请选择">
            <el-option label="未分账" value="1"></el-option>
            <el-option label="不完全分帐" value="2"></el-option>
            <el-option label="完全分帐" value="4"></el-option>
            <el-option label="处理中" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataPage">查询</el-button>
          <el-button type="info" @click="handleExcel">EXCEL</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" size="mini" show-summary :summary-method="getSummaries">
        <el-table-column prop="applyname" label="应用" width="160">
        </el-table-column>
        <el-table-column prop="merchname" label="商户" width="380">
        </el-table-column>
        <el-table-column prop="payment" label="支付方式" width="100">
          <template slot-scope="scope">
            {{ scope.row.payment==='wx'?'微信':scope.row.payment==='zfb'?'支付宝':scope.row.payment==='twx'?'腾讯微信':scope.row.payment==='dyzfb'?'Alipay支付宝':scope.row.payment==='ybwx'? '微信 支付' :scope.row.payment==='ybzfb'? '支付宝 支付' :'小程序' }}
            <!-- {{ scope.row.payment==='wx'?'微信':scope.row.payment==='zfb'?'支付宝':scope.row.payment==='twx'?'腾讯微信':scope.row.payment==='ybwx'?'微信 支付':scope.row.payment==='ybzfb'?'支付宝 支付':'' }} -->
          </template>
        </el-table-column>

        <el-table-column label="实付金额" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.totalamount }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="分润总金额" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.totalabonus }}
          </template>
        </el-table-column>
        <el-table-column prop="billmonth" label="月份" width="100"></el-table-column>
        <el-table-column prop="thoroug" label="通道比例" width="100">
          <template slot-scope="scope">
            {{ scope.row.thoroug }}%
          </template>
        </el-table-column>
        <el-table-column prop="thorougamount" label="通道金额" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.thorougamount }}
          </template>
        </el-table-column>
        <el-table-column prop="terrace" label="平台分账比例" width="100">
          <template slot-scope="scope">
            {{ scope.row.terrace }}%
          </template>
        </el-table-column>
        <el-table-column prop="terraceamount" label="平台分账金额" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.terraceamount }}
          </template>
        </el-table-column>
        <el-table-column prop="merchant" label="商户分账比例" width="100">
          <template slot-scope="scope">
            {{ scope.row.merchant }}%
          </template>
        </el-table-column>

        <el-table-column prop="merchantamount" label="商户分账金额" width="100">
          <template slot-scope="scope">
            ￥{{ scope.row.merchantamount }}
          </template>
        </el-table-column>
        <el-table-column prop="totaldifference" label="差额">
          <template slot-scope="scope">
            ￥{{ scope.row.totaldifference }}
          </template>
        </el-table-column>
        <el-table-column prop="billstate" label="分账状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.billstate == '1'" type="primary" disable-transitions>未分账</el-tag>
            <el-tag v-if="scope.row.billstate == '2'" type="success" disable-transitions>不完全分帐</el-tag>
            <el-tag v-if="scope.row.billstate == '3'" type="success" disable-transitions>处理中</el-tag>
            <el-tag v-if="scope.row.billstate == '4'" type="success" disable-transitions>完全分帐</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button @click="handleDetail(scope.$index, scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="excel(scope.row)" type="text" size="small">导出</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;margin:10px"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <el-dialog title="分账明细" :visible.sync="dialogTableVisible" width="80%">
      <el-table :data="gridData" size="mini" height="400">
        <el-table-column prop="orderno" label="订单号" width="200"></el-table-column>
        <el-table-column prop="orderDate" label="订单时间" width="150"></el-table-column>
        <el-table-column prop="productName" label="商品名称" width="280"></el-table-column>
        <el-table-column prop="payment" label="支付方式" width="100">
          <template slot-scope="scope">
            {{ scope.row.payment==='wx'?'微信':scope.row.payment==='zfb'?'支付宝':scope.row.payment==='twx'?'腾讯微信':scope.row.payment==='ybwx'?'微信 支付':scope.row.payment==='ybzfb'?'支付宝 支付':'' }}
          </template>
        </el-table-column>
        <el-table-column prop="initAmount" label="订单金额" width="100"></el-table-column>
        <el-table-column prop="amount" label="实付金额" width="100"></el-table-column>
        <el-table-column prop="thoroug" label="通道分帐比例" width="100"></el-table-column>
        <el-table-column prop="thorougamount" label="通道分帐金额" width="100"></el-table-column>
        <el-table-column prop="abonus" label="可分帐金额" width="100"></el-table-column>
        <el-table-column prop="terrace" label="平台分帐比例" width="100"></el-table-column>
        <el-table-column prop="terraceamount" label="平台分帐金额" width="100"></el-table-column>
        <el-table-column prop="merchant" label="商户分帐比例" width="100"></el-table-column>
        <el-table-column prop="merchantamount" label="商户分帐金额" width="100"></el-table-column>
        <el-table-column prop="cpdifference" label="差额" width="100"></el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import E from 'wangeditor'
export default {
  data () {
    return {
      billmonth:[],
      pageresult:{},
      summary:{},
      formSearch: {
        applyname: '',
        payment:'',
        billmonth: '',
        pageNum:1
      },
      tableData:[],
      gridData:[],
      dialogTableVisible:false,
    }
  },
  created(){
    this.getDataPage();
  },
  methods: {
    handleCurrentChange(val) {
      this.formSearch.pageNum=val;
      this.getDataPage();
    },
    formatDate(row, column) {
      return moment(row.createdate).format("YYYY-MM-DD HH:mm");
    },
    getDataPage(){
      let info = this.$store.state.userInfo;
      this.formSearch.merchno=info.userbh;
      if (this.billmonth != null) {
        this.formSearch.start = this.billmonth[0] || '';
        this.formSearch.end = this.billmonth[1] || '';
      }else {
        this.formSearch.start = '';
        this.formSearch.end = '';
      }
      let that = this;
      this.$ajax({
        url:"coupon-merch/merch/getBills",
        async:false,
        data:that.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.tableData=response.data.content;
            that.pageresult = response.data;
            that.getSummary(that.formSearch);
          }else{
            that.$message.error(response.message);
          }
        }
      })
    },
    //查询合计
    getSummary(param){
      let _this = this;
      this.$ajax({
        url:"coupon-merch/merch/getBillSummary",
        async:false,
        data: param,
        success:function(response){
          if (response.code== 0) {
            _this.summary = response.data;
          }else{
            _this.$message.error(response.message);
          }
        }
      })
    },
    handleDetail(index,row){
      let that = this;
      that.$ajax({
        url:"coupon-merch/merch/getBillThoroug",
        async:false,
        data:{'merchno':row.merchno,'applyno':row.applyno,'billmonth':row.billmonth,'payment':row.payment,'sourceMainMch':row.sourceMainMch},
        methods:'GET',
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.gridData = response.data;
            that.dialogTableVisible = true;
          }else{
            that.$message.error('查询失败');
          }
        },
        error:function(){
          that.$message.error('请求失败');
        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        if (index === 3) {
          sums[index] = this.summary.totalamount;
          return;
        }
        if (index === 4) {
          sums[index] = this.summary.totalabonus;
          return;
        }

        if (index === 7) {
          sums[index] = this.summary.thorougamount;
          return;
        }

        if (index === 19) {
          sums[index] = this.summary.terraceamount;
          return;
        }
        if (index === 11) {
          sums[index] = this.summary.merchantamount;
          return;
        }
        if (index === 12) {
          sums[index] = this.summary.totaldifference;
          return;
        }
      });
      return sums;
    },
    download (data,fileName) {
        if (!data) {
            return;
        }
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.target = "_blank";
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    },
    excel(row){
      this.$download('coupon-merch/merch/excel_bill_thoroug',{'merchno':row.merchno,'applyno':row.applyno,'billmonth':row.billmonth,'payment':row.payment}).then((res) => {
        this.download(res,'分账单明细.xlsx');
      }).catch(err => {
        this.$message.error("下载失败");
     })
    },
    handleExcel(){
      let info = this.$store.state.userInfo;
      this.formSearch.merchno = info.userbh;
      if (this.billmonth != null) {
        this.formSearch.start = this.billmonth[0] || '';
        this.formSearch.end = this.billmonth[1] || '';
      }else {
        this.formSearch.start = '';
        this.formSearch.end = '';
      }
      this.$download('coupon-merch/merch/bill_excel',this.formSearch).then((res) => {
        this.download(res,'分账单.xlsx');
      }).catch(err => {
        this.$message.error("下载失败");
     })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/merch/mer_bill.vue